export default '/pricing/tier-extension';
